import React from 'react'
import {
    NEW_URL
} from "../../../../constants/applicationConstants.js";
import uploadicon from "../../../../assets/images/uploadicon.svg"
import { useTranslation } from "react-i18next";

const LogoJsx = (props) => {
    const {
        imgURL, onFileChange, profileImagePreviewUrl, onNextButtonClick
    } = props;
    const { t } = useTranslation();
    return (
        <>
            <div className="myaccountsection institutedetails">
                <div className="myaccountsectionheading">
                    <h3 className="h3_style">{t("expertDashboard.Profile_picture")}</h3>
                    {/* <div className="mybtn">
                        <button type="button" className="myadbtn" onClick={() => changeLogoState(true)}><img src={Subtract} /></button>
                    </div> */}
                </div>
                <div className="logoform">
                    <div className="form-fieldinner">
                        {/* <img className="dashboardlogo" src={`${NEW_URL}/${imgURL}`} /> */}
                        {
                            profileImagePreviewUrl ?
                                <img
                                    src={profileImagePreviewUrl}
                                    height="170px"
                                    width="250px"
                                    alt="edit profile"
                                    className="logoclass"
                                /> :

                                <img
                                    src={`${NEW_URL}/${imgURL}`}
                                    height="170px"
                                    width="250px"
                                    alt="edit profile"
                                    className="logoclass"
                                />

                        }
<div className="uploadsec">
<div className="uploadinnersec"><h1 className="file-heading">{t("instituteAccountSetting.FILENAMETEXT")}</h1>
<h1 className="file-name">{profileImagePreviewUrl ?profileImagePreviewUrl.split('/').pop():imgURL.split('/').pop()}</h1> 
</div>   <div className="uploaddetails">
                            {/* <input type="file" onChange={onFileChange}></input> */}

                            <div className="img-uplod-section">

                                <div className="btn_upload">
                                    <input type="file" id="upload_file" name="" onChange={onFileChange} accept="image/png, image/gif, image/jpeg" />
                                    <label className="change_button" for="upload_file">{t("expertDashboard.Choose_Picture")} <img src={uploadicon} alt='uploadImage'/></label>
                                </div>
                            </div>
                            <button type="button" className="ctaonebutton" disabled={!profileImagePreviewUrl} onClick={() => onNextButtonClick()}>Upload Picture</button>
                            {/* <button type="button" className="ctaonebutton" onClick={() => changeLogoState(true)}>Change Logo</button> */}
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LogoJsx;
